module.exports = __webpack_public_path__ + "static/media/IMG_8022.c7e859d9.jpg";